module.exports = __webpack_public_path__ + "img/info.001.fd96a69b.jpeg";